import styled from 'styled-components'

export const PageWrapper = styled.div`
  display: flex;
  padding: 40px 200px 40px 40px;
`
